import { render } from "./InvitationModals.vue?vue&type=template&id=21e7829f"
import script from "./InvitationModals.vue?vue&type=script&lang=js"
export * from "./InvitationModals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__